module.exports = __webpack_public_path__ + "img/coinbankB41.c97d017e.jpg";